import { defineNuxtPlugin } from "#app";
import ToastPlugin, * as ToastExports from "vue-toastification";
import "vue-toastification/dist/index.css";

const { POSITION } = ToastExports;

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(ToastPlugin, {
    position: POSITION.TOP_RIGHT,
  });
});
